import _ from 'lodash';
import path from 'path';
import fs from 'fs';
import { log, setApp } from '@swiper/core';
import config from '~/config';

export * from './app/lib/Plugin';

// Eliminate sensitive stuff from the config that we don't need to
// have in server memory
[
  'provisioning',
  'importer',
].forEach( x => delete config.data[ x ] );

export async function build() {
  await config.finalize();
  const { default : app } = await import( './app' );
  setApp( app );
  return app;
}

export async function start( opts={} ) {
  const app = await build();

  const server = app.listen( opts.port, opts.host );
  server.on( 'listening', () => {
    log.info( `Listening on http://${opts.host}:${opts.port}` );
  } );
  return server;
}
